import Vue from 'vue';
import axios from 'axios';

export default {
  name: 'ChangeEmail',
  components: {
    EmailComp: require('../../components/email.vue').default,
  },
  data: function () {
    return {
      email: { email: '', valid: false, descr: 'New Email'},
      currentEmail: { email: '', valid: false, descr: 'Current Email'},
      password: '',
      completed: false,
      showMsg: false,
      message: '',
      isInComm: false,
      code: '',
    }
  },
  computed: {
    changeEnabled: function () {
      return this.email.valid && this.currentEmail.valid && !this.isInComm && !this.completed;
    },
  },
  created() {
    this.code = this.$route.params.code;
  },
  methods: {
    changeEmail() {
      this.isInComm = true;
      axios.post('/account/ChangeEmail', { Email: this.currentEmail.email, Password: this.password, ActivationCode: this.code, NewEmail: this.email.email })
        .then(response => {
          this.isInComm = false;
          if (response.status == 200 && (!response.data || response.data.data.status == 0)) {
            this.message = this.$i18n.t('changeEmail.sendEmail');
            this.completed = true;
          }
          else {
            this.message = response.data.data.text;
            setTimeout(() => { this.showMsg = false; }, 3000);
          }
          this.showMsg = true;
        })
        .catch(e => { this.message = e.message; this.completed = true; this.showMsg = true; })
    },
  },
}
